import React, { useState } from "react";
import {
  Box,
  Typography,
  useMediaQuery,
  Paper,
  Card,
  CardContent,
  Button,
  CircularProgress,
  Avatar,
  Stack,
  List,
  Divider,
  useTheme,
  IconButton,
} from "@mui/material";
import { useAppSelector, useAppDispatch } from "../hooks/hooks";
import CowIcon from "./CowIcon";
import {
  Loan,
  LoanPool,
  LoanStatus,
  LoanView,
  Repayment,
} from "../types/loanTypes";
import { RootState } from "../redux/store";
import { setCurrentMooloanView } from "../redux/uiSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RepaymentView from "./Loans/RepaymentView";
import PersonalLoansView from "./Loans/PersonalLoansView";
import NewLoanView from "./Loans/NewLoanView";
import InvestmentView from "./Loans/InvestmentView";

const LoansComponent: React.FC = () => {
  const { currentMooloanView } = useAppSelector((state: RootState) => state.ui);
  const isMobile = useMediaQuery("(max-width:600px)");
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Sample data - replace with real API calls
  const personalLoans: Loan[] = [
    {
      id: "1",
      cattlePhoto: "ipfs://...",
      amount: 500,
      currency: "AGD",
      interestRate: 10,
      term: 6,
      status: "active" as LoanStatus,
      nextPayment: "2023-11-15",
      cattleDetails: {
        tagNumber: "BOV-001",
        breed: "Angus",
        age: 3,
        estimatedValue: 800,
      },
    },
  ];

  const investmentPools: LoanPool[] = [
    {
      id: "pool-1",
      name: "Premium Cattle Pool",
      totalValue: 25000,
      activeLoans: 42,
      defaultRate: 2.5,
      avgInterest: 11.2,
    },
  ];

  const handleBack = () => {
    dispatch(setCurrentMooloanView("personal"));
  };

  if (isLoading) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="body2" sx={{ mt: 2 }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <Paper
      elevation={isMobile ? 0 : 1}
      sx={{ p: isMobile ? 1 : 2, borderRadius: 2 }}
    >
      {currentMooloanView === "personal" ? (
        <PersonalLoansView loans={personalLoans} isMobile={isMobile} />
      ) : currentMooloanView === "investment" ? (
        <InvestmentView pools={investmentPools} isMobile={isMobile} />
      ) : currentMooloanView === "new-loan" ? (
        <NewLoanView isMobile={isMobile} onBack={handleBack} />
      ) : (
        <RepaymentView isMobile={isMobile} onBack={handleBack} />
      )}
    </Paper>
  );
};

export default LoansComponent;
